import { Component } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../../filter/filter.model';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { MatDialog } from '@angular/material/dialog';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Sort } from '@angular/material/sort';
import { AddDepartmentComponent } from '../add-department/add-department.component';
import { DepartmentService } from 'src/app/services/department/department.service';
import { MatTableDataSource } from '@angular/material/table';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { ViewAssignedEmployeeComponent } from '../view-assigned-employee/view-assigned-employee.component';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss']
})
export class DepartmentComponent {
  public imageURL: string = GlobalService.imageURL
  public count!: any;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms" }
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public isFilterShow: boolean = false;
  public dataSource;
  public displayedColumns: string[] = ['dep_name', 'action'];
  // public displayedColumns: string[] = ['package_name' ,'price', 'package_status', 'status','admin_comment','action'];
  public filterArr: any[] = [
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Department", key_val: "dep", type: 'select' },
    { key_name: "Start Date", key_val: "st_dt", type: 'date' },
    { key_name: "End Date", key_val: "ed_dt", type: 'date' },
  ];
  public searchInput: string = '';
  private previousInputValue: string = '';
  constructor(private appService: AppService, private commonService: CommonService,
    private _liveAnnouncer: LiveAnnouncer, private dialog: MatDialog, private departmentService: DepartmentService,) { }
  ngOnInit() {
    this.commonService.setTitle("Department Management")
    this.getList()
  }
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.getList();
    // this.noticesList()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.getList();
    // this.noticesList()
  }
  onAddEditDepartment(item) {
    let obj = {
      width: '50%',
      maxWidth: '500px',
      minWidth: '300px',
      height: '98%',
      maxHeight:'300px',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: "300ms",
      panelClass: "hire",
      autoFocus: false,
      data: {}
    }
    if (item) {
      let objItem = {
        edit: true,
        editData: item
      }
      obj["data"] = objItem
    }
    const dialogRef = this.dialog.open(AddDepartmentComponent, obj);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result['data_added'] == true) {
        this.getList()
      }
    });
  }
  onDeleteItem(item) { }
  onEditItem(item) { }
  getList() {
    // this.spinner.show();
    this.isSpinnerLoading = true;
    let obj = {
      sh: this.searchInput.trim(),
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand
    }
    // this.departmentService.list(obj).subscribe( {
    this.departmentService.list(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        this.isSpinnerLoading = false
        if (success.status == 200) {
          this.previousInputValue=this.searchInput
          this.count = success.count
          this.dataSource = new MatTableDataSource(success.data)
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    }
    )
  }
  onDelete(id: number) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_department", id: id }
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getList()
      }
    });
  }
  onViewManager(element){
    const dialogRef = this.dialog.open(ViewAssignedEmployeeComponent,Object.assign({
      data: { id:element.cd_i,type:"view_department_assigned"},
      height:'100%',
      width:'60%',
      maxHeight:'746px',
      maxWidth:'1182px',
      minWidth:'290px'
    }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getList()
      }
    });
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage=1
      this.getList()
    }
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.config.currentPage=1
      this.getList()
    }
  }

}
